import {
  DefaultToastOptions,
  Message,
  Renderable,
  ToastOptions,
  ValueOrFunction,
} from "@/@types/toast";
import rht from "react-hot-toast";

const id = "toast-id";

const toast = {
  success: (message: Message, opts?: ToastOptions) => {
    return rht.success(message, { id, ...opts });
  },
  error: (message: Message, opts?: ToastOptions) => {
    return rht.error(message, { id, ...opts });
  },
  loading: (message: Message, opts?: ToastOptions) => {
    return rht.loading(message, { id, ...opts });
  },
  custom: (message: Message, opts?: ToastOptions) => {
    return rht.custom(message, { id, ...opts });
  },
  dismiss: (toastId?: string) => {
    return rht.dismiss(toastId || id);
  },
  remove: (toastId?: string) => {
    return rht.remove(toastId || id);
  },
  promise: <T>(
    p: Promise<T>,
    msgs: {
      loading: Renderable;
      success: ValueOrFunction<Renderable, T>;
      error: ValueOrFunction<Renderable, any>;
    },
    opts?: DefaultToastOptions,
  ): Promise<T> => {
    return rht.promise(p, msgs, { id, ...opts });
  },
};

export default toast;
